var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 36,
    viewBox: "0 0 61 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.4983L11.0875 7.1302C12.65 3.13256 16.5033 0.501465 20.7954 0.501465H27.4799L16.3924 28.8695C14.8299 32.8672 10.9766 35.4983 6.68451 35.4983H0Z",
    fill: "url(#paint0_linear_569_4938)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2659 35.4984L27.3534 7.13028C28.9158 3.13265 32.7691 0.501548 37.0612 0.501548H43.7458L32.6582 28.8696C31.0958 32.8673 27.2425 35.4984 22.9504 35.4984H16.2659Z",
    fill: "url(#paint1_linear_569_4938)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5327 35.4984L43.6202 7.13028C45.1826 3.13265 49.0359 0.501548 53.328 0.501548H60.0125L48.925 28.8696C47.3626 32.8673 43.5093 35.4984 39.2172 35.4984H32.5327Z",
    fill: "url(#paint2_linear_569_4938)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_4938",
    x1: 60.0127,
    y1: -2.17168,
    x2: -0.00000196853,
    y2: 31.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_4938",
    x1: 60.0127,
    y1: -2.17168,
    x2: -0.00000196853,
    y2: 31.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_569_4938",
    x1: 60.0127,
    y1: -2.17168,
    x2: -0.00000196853,
    y2: 31.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E62"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d2b85820402c7c64be6b39102921fdb8.svg";
export { ForwardRef as ReactComponent };